module.exports = "/images/arrow.png?b6fe5579a2fe3488d950e6b684db0644";